module.exports = __webpack_public_path__ + "static/media/machobanners_sm1.4e06abf6.png";